import { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Pagination,
  Row,
} from "reactstrap";
import EnterpriseService from "../../common/services/enterprise-service";
import Paginator from "../ui/Paginator";
import LazyImage from "../../web/components/common/LazyImage";
import UserDefinedUnits from "../../common/utils/UserDefinedUnits";
import { EnterpriseContext } from "./EnterpriseContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactSelectUserOption from "../ui/ReactSelectUserOption";
import reactSelectCustomStyles from "../../common/plugins/reactSelectStyles";
import Select from "react-select";
import { confirmWrapper } from "../ui/askConfirm";
import { toast, ToastContainer } from "react-toastify";

export default function UsedVehiclesMarket({ container }) {
  const es = new EnterpriseService();

  const { globalContext } = useContext(EnterpriseContext);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [usedVehiclesParameters, setUsedVehiclesParameters] = useState({
    page: 1,
    perPage: 24,
    model_id: null,
    brand_id: null,
    game_id: null,
    type: "truck",
  });
  const [vehicles, setVehicles] = useState([]);
  const [members, setMembers] = useState([]);
  const [garages, setGarages] = useState([]);
  const [vehicleToBuy, setVehicleToBuy] = useState(null);
  const [showBuyVehicleModal, toggleBuyVehicleModal] = useState(false);

  useEffect(() => {
    getBrands();
    getModels();
  }, []);

  useEffect(() => {
    getUsedVehicles();
  }, [
    usedVehiclesParameters.brand_id,
    usedVehiclesParameters.type,
    usedVehiclesParameters.game_id,
    usedVehiclesParameters.model_id,
    usedVehiclesParameters.page,
    usedVehiclesParameters.perPage,
  ]);

  const getBrands = async () => {
    const result = await es.getAllBrands();
    setBrands(result);
  };

  const getModels = async () => {
    const result = await es.getAllModels();
    setModels(result);
  };

  const getUsedVehicles = async () => {
    const result = await es.getUsedVehicles(usedVehiclesParameters);
    setVehicles(result.data);
    setTotalPages(result.last_page);
  };

  const handlePageClick = (event) => {
    setUsedVehiclesParameters({
      ...usedVehiclesParameters,
      page: event.selected + 1,
    });
  };

  const handleRowsPerPageChange = (perPage) => {
    setUsedVehiclesParameters({
      ...usedVehiclesParameters,
      page: 1,
      perPage: perPage,
    });
  };

  const getGarages = async () => {
    const result = await es.getGarages(globalContext.company);
    if (!result.message) setGarages(result);
  };

  const getMembers = async () => {
    const result = await es.getMembers(globalContext.company, {
      perPage: 9999,
    });
    setMembers(result.data);
  };

  useEffect(() => {
    if (vehicleToBuy) {
      if (garages.length == 0) {
        getGarages();
      }

      if (members.length == 0) {
        getMembers();
      }

      toggleBuyVehicleModal(true);
    } else {
      toggleBuyVehicleModal(false);
    }
  }, [vehicleToBuy]);

  const save = async () => {
    if (
      await confirmWrapper(container.localeManager.strings.buyVehicleConf, {
        container: container,
      })
    ) {
      const result = await es.buyUsedVehicle(globalContext.company, {
        id: vehicleToBuy.id,
        garage_id: vehicleToBuy.garage_id,
        assigned_to_user_id: vehicleToBuy.assigned_to_user_id,
      });
      if (result.success) {
        toast.success(container.localeManager.strings.deal);
        setVehicleToBuy(null);
      } else {
        toast.error(result.message);
      }
    }
  };

  return (
    <>
      <FormGroup row>
        <Col sm={3}>
          <Label>{container.localeManager.strings.brand}</Label>
          <Input
            type="select"
            onChange={(e) => {
              setUsedVehiclesParameters({
                ...usedVehiclesParameters,
                brand_id: e.target.value,
              });
            }}
            value={usedVehiclesParameters.brand_id}
          >
            <option value={null}></option>
            {brands.map((m) => {
              return (
                <option value={m.id} key={m.id}>
                  {m.name}
                </option>
              );
            })}
          </Input>
        </Col>
        <Col sm={3}>
          <Label>{container.localeManager.strings.model}</Label>
          <Input
            type="select"
            onChange={(e) => {
              setUsedVehiclesParameters({
                ...usedVehiclesParameters,
                model_id: e.target.value,
              });
            }}
            value={usedVehiclesParameters.model_id}
          >
            <option value={null}></option>
            {models.map((m) => {
              return (
                <option value={m.id} key={m.id}>
                  {m.full_name}
                </option>
              );
            })}
          </Input>
        </Col>
        <Col sm={3}>
          <Label>{container.localeManager.strings.game}</Label>
          <Input
            type="select"
            onChange={(e) => {
              setUsedVehiclesParameters({
                ...usedVehiclesParameters,
                game_id: e.target.value,
              });
            }}
            value={usedVehiclesParameters.game_id}
          >
            <option value={null}></option>
            <option value={1}>Euro Truck Simulator 2</option>
            <option value={2}>American Truck Simulator</option>
          </Input>
        </Col>
        <Col sm={3}>
          <Label>{container.localeManager.strings.type}</Label>
          <Input
            type="select"
            onChange={(e) => {
              setUsedVehiclesParameters({
                ...usedVehiclesParameters,
                type: e.target.value,
              });
            }}
            value={usedVehiclesParameters.type}
          >
            <option value={null}>{container.localeManager.strings.all}</option>
            <option value={"truck"}>
              {container.localeManager.strings.truck}
            </option>
            <option value={"bus"}>{container.localeManager.strings.bus}</option>
          </Input>
        </Col>
      </FormGroup>
      <div>
        <Paginator
          rowsPerPageSelected={usedVehiclesParameters.perPage}
          handleRowsPerPageChange={handleRowsPerPageChange}
          showRowsPerPage={true}
          forcePage={usedVehiclesParameters.page - 1}
          totalPages={totalPages}
          handlePageClick={handlePageClick}
        ></Paginator>

        <div className="grid cols-3 gap-1 my-3">
          {vehicles.map((m) => {
            return (
              <>
                <Card className="bg-secondary">
                  <CardBody>
                    <div className="fs-4 d-flex justify-content-between">
                      <div>
                        <img
                          src={m.model.brand.logo_url}
                          className="h-30px"
                        ></img>{" "}
                        {m.model.full_name}
                      </div>
                      <div className="text-danger">
                        <FontAwesomeIcon icon="wrench"></FontAwesomeIcon>{" "}
                        {container.localeManager
                          .numeral(m.unfixable_wear)
                          .format("0")}
                        %
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <img
                        src={m.model.photo_url}
                        className="w-150px"
                        alt={m.model.full_name}
                      />
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <LazyImage
                        src={m.company.avatar_url}
                        className="w-30px me-3 rounded"
                      />
                      <Link to={`/company/${m.company_id}`}>
                        {m.company.name}
                      </Link>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div className="fs-3">
                        {UserDefinedUnits.convertDistance(
                          globalContext.member,
                          m.game_id,
                          m.odometer_km
                        )}
                      </div>
                      <div>
                        <strike className="text-warning me-2">
                          {container.localeManager
                            .numeral(m.model.price)
                            .format("0,0")}{" "}
                          T¢
                        </strike>
                        <span className="text-success fs-3">
                          {container.localeManager
                            .numeral(m.used_price)
                            .format("0,0")}{" "}
                          T¢
                        </span>
                        <Button
                          color="text"
                          size="sm"
                          className="ms-2 border-success"
                          onClick={() => setVehicleToBuy(m)}
                        >
                          <FontAwesomeIcon
                            icon="cart-plus"
                            className="mx-0 text-success"
                            size="2x"
                          ></FontAwesomeIcon>
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </>
            );
          })}
        </div>
        <Paginator
          rowsPerPageSelected={usedVehiclesParameters.perPage}
          handleRowsPerPageChange={handleRowsPerPageChange}
          showRowsPerPage={true}
          forcePage={usedVehiclesParameters.page - 1}
          totalPages={totalPages}
          handlePageClick={handlePageClick}
        ></Paginator>
        {vehicleToBuy && (
          <Modal isOpen={showBuyVehicleModal} size="lg">
            <ModalHeader toggle={() => setVehicleToBuy(null)}></ModalHeader>
            <ModalBody>
              <div className="d-flex flex-column justify-content-center align-align-items-center fs-2 fw-bold w-100">
                <div className="text-center">
                  {vehicleToBuy.model.full_name}
                </div>
                <div className="text-center">
                  <img
                    src={vehicleToBuy.model.photo_url}
                    className="h-150px"
                  ></img>
                </div>
                <div className="text-center text-success">
                  {container.localeManager
                    .numeral(vehicleToBuy.used_price)
                    .format("0,0")}{" "}
                  T¢
                </div>
              </div>
              <Row className="mt-3">
                <Col>
                  {garages.length > 0 && (
                    <FormGroup>
                      <Label>
                        {container.localeManager.strings.chooseGarage}
                      </Label>
                      <Input
                        type="select"
                        onChange={(e) =>
                          setVehicleToBuy({
                            ...vehicleToBuy,
                            garage_id: e.target.value,
                          })
                        }
                      >
                        <option>
                          {container.localeManager.strings.pleaseSelectGarage}
                        </option>
                        {garages.map((g) => {
                          return <option value={g.id}>{g.city.name}</option>;
                        })}
                      </Input>
                    </FormGroup>
                  )}
                </Col>
                <Col>
                  {members.length > 0 &&
                    es.can(globalContext.member, "vehicles.assign") && (
                      <FormGroup>
                        <Label>
                          {container.localeManager.strings.assignedDriver}
                        </Label>
                        <Select
                          styles={reactSelectCustomStyles}
                          value={
                            members.find(
                              (m) => m.id === vehicleToBuy.assigned_to_user_id
                            ) || null
                          }
                          isClearable={true}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          options={members}
                          onChange={(e) =>
                            setVehicleToBuy({
                              ...vehicleToBuy,
                              assigned_to_user_id: e ? e.id : null,
                            })
                          }
                          components={{
                            Option: ReactSelectUserOption,
                          }}
                        ></Select>
                      </FormGroup>
                    )}
                </Col>
              </Row>
              {vehicleToBuy && vehicleToBuy.garage_id && (
                <Row>
                  <Col>
                    <FormGroup className="mt-3">
                      <Button onClick={save} color="primary">
                        {container.localeManager.strings.buy}
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </ModalBody>
          </Modal>
        )}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
}
